import { defineMessages } from 'react-intl';

export const scope = 'loop.containers.Jobs.Filters';

export default defineMessages({
  FiltersHeading: {
    id: `${scope}.filtersHeading`,
    defaultMessage: 'Filtriraj pretragu',
  },
  EnterCity: {
    id: `${scope}.enterCity`,
    defaultMessage: 'Izaberi grad',
  },
  Position: {
    id: `${scope}.position`,
    defaultMessage: 'Pozicija (Primer: vozač, marketing asistent...)',
  },
  FieldOfWork: {
    id: `${scope}.fieldOfWork`,
    defaultMessage: 'Oblast rada',
  },
  SearchByKeyword: {
    id: `${scope}.searchByKeyword`,
    defaultMessage: 'Pretraga po ključnoj reči',
  },
  Seniority: {
    id: `${scope}.seniority`,
    defaultMessage: 'Senioritet',
  },
  PositionLevel: {
    id: `${scope}.positionLevel`,
    defaultMessage: 'Nivo pozicije',
  },
  EmploymentType: {
    id: `${scope}.employmentType`,
    defaultMessage: 'Tip zaposlenja',
  },
  Employer: {
    id: `${scope}.employer`,
    defaultMessage: 'Poslodavac',
  },
  Salary: {
    id: `${scope}.salary`,
    defaultMessage: 'Nivo zarade',
  },
  Industry: {
    id: `${scope}.industry`,
    defaultMessage: 'Industrija',
  },
  Language: {
    id: `${scope}.language`,
    defaultMessage: 'Jezik',
  },
  searching: {
    id: `${scope}.searching`,
    defaultMessage: 'Pretraga u toku...',
  },
  emptyLabel: {
    id: `${scope}.emptyLabel`,
    defaultMessage: 'Nema rezulata pretrage',
  },
  Searching: {
    id: `${scope}.searching`,
    defaultMessage: 'Pretraži',
  },
  AdditionalFilters: {
    id: `${scope}.additionalFilters`,
    defaultMessage: 'Dodatni filteri',
  },
  HideAdditionalFilters: {
    id: `${scope}.hideAdditionalFilters`,
    defaultMessage: 'Zatvori dodatne filtere',
  },
  JobDisability: {
    id: `${scope}.jobDisability`,
    defaultMessage: 'Posao za osobe sa invaliditetom',
  },
  JobAge: {
    id: `${scope}.jobAge`,
    defaultMessage: 'Posao za osobe sa 50+ godina starosti',
  },
  JobStudent: {
    id: `${scope}.jobStudent`,
    defaultMessage: 'Poslovi za studente',
  },
  JobAbroad: {
    id: `${scope}.JobAbroad`,
    defaultMessage: 'Poslovi u inostranstvu',
  },
  JobSalary: {
    id: `${scope}.JobSalary`,
    defaultMessage: 'Samo poslovi sa naznačenom platom',
  },
  Remote: {
    id: `${scope}.remote`,
    defaultMessage: 'Rad od kuće',
  },
  ProminentAdsTitle: {
    id: `${scope}.prominentAdsTitle`,
    defaultMessage: 'Premium oglasi',
  },
  OurOfferTitle: {
    id: `${scope}.ourOfferTitle`,
    defaultMessage: 'Naša ponuda',
  },
  AdsCreation: {
    id: `${scope}.adsCreation`,
    defaultMessage: 'Postavljanje oglasa',
  },
  AdsCreationDesc: {
    id: `${scope}.adsCreationDesc`,
    defaultMessage: 'loop ti nudi različite mogućnosti kreiranja oglasa u zavisnosti od tvojih potreba.',
  },
  AdsCreationDesc2: {
    id: `${scope}.adsCreationDesc2`,
    defaultMessage: 'Odaberi unared pripremljene opise dužnosti i zahteva koje je loop pripremio za određene pozicije, potpuno samostalno kreiraj svoj oglas ili dozvoli loop konsultantu da u potpunosti kreira sadržaj oglasa na osnovu tvoje glasovne poruke.',
  },
  SignUpCandidates: {
    id: `${scope}.signUpCandidates`,
    defaultMessage: 'Procena prijavljenih kandidata',
  },
  SignUpCandidatesDesc: {
    id: `${scope}.signUpCandidatesDesc`,
    defaultMessage: 'Nakon aktiviranja usluge procene prijavljenih kandidata, loop će ti prikazati odgovarajuće i neodgovarajuće prijavljene kandidate, uz isticanje do TOP 10 prijava.',
  },
  SignUpCandidatesDesc2: {
    id: `${scope}.signUpCandidatesDesc2`,
    defaultMessage: 'loop obezbeđuje prilagođena rešenja u predselekciji za specifične zahteve i potrebe.',
  },
  BestCandidates: {
    id: `${scope}.bestCandidates`,
    defaultMessage: 'Odabir najboljih kandidata',
  },
  BestCandidatesDesc: {
    id: `${scope}.bestCandidatesDesc`,
    defaultMessage: 'Nakon aktivirane usluge odabira najboljih kandidata, loop će ti prikazati odgovarajuće i neodgovarajuće prijavljene kandidate i preporučiti TOP 5 najboljih kandidata po otvorenoj poziciji',
  },
  BestCandidatesDesc2: {
    id: `${scope}.bestCandidatesDesc2`,
    defaultMessage: 'loop obezbeđuje prilagođena rešenja u selekciji za specifične zahteve i potrebe.',
  },
  ClickFromYouTest: {
    id: `${scope}.clickFromYouTest`,
    defaultMessage: 'Uskoro na klik od tebe - usluge iz oblasti profesionalne procene i testiranja.',
  },
  ClickFromYouDev: {
    id: `${scope}.clickFromYouDev`,
    defaultMessage: 'Uskoro na klik od tebe - usluge iz oblasti profesionalnog razvoja.',
  },
  ClickFromYouMarketResearch: {
    id: `${scope}.clickFromYouMarketResearch`,
    defaultMessage: 'Uskoro na klik od tebe - usluge iz oblasti istraživanja tržišta.',
  },
  ClickFromYouDesc: {
    id: `${scope}.clickFromYouDescDev`,
    defaultMessage: 'Stručni ljudi su ključ svakog uspešnog biznisa. Kreirajte Vaš oglas',
  },
  RegistrationAndSelection: {
    id: `${scope}.registrationAndSelection`,
    defaultMessage: 'Registracija i selekcija',
  },
  MarketResearch: {
    id: `${scope}.marketResearch`,
    defaultMessage: 'Istraživanje tržišta',
  },
  MarketResearchDesc: {
    id: `${scope}.marketResearchDesc`,
    defaultMessage: 'loop sa svojim partnerima donosi relevantne informacije sa tržišta i ekspertske smernice u vezi sa strateškim pitanjima vezanim za vaše poslovanje. Putem Loop-a ćeš saznati:',
  },
  MarketResearchDesc2: {
    id: `${scope}.marketResearchDesc2`,
    defaultMessage: 'I još mnogo toga...',
  },
  MarketResearchDesc3: {
    id: `${scope}.marketResearchDesc3`,
    defaultMessage: 'Nakon popunjavanja upita, u toku od 48h ćeš dobiti informacije o ceni i trajanju usluge.',
  },
  MarketResearchDescList1: {
    id: `${scope}.marketResearchDescList1`,
    defaultMessage: 'Kako se kreću zarade na tržištu za određenu poziciju/pozicije',
  },
  MarketResearchDescList2: {
    id: `${scope}.marketResearchDescList2`,
    defaultMessage: 'Kako uspostaviti odgovarajući sistem kompenzacija i beneficija',
  },
  MarketResearchDescList3: {
    id: `${scope}.marketResearchDescList3`,
    defaultMessage: 'Koliko su vaši zaposleni zadovoljni i uključeni',
  },
  MarketResearchDescList4: {
    id: `${scope}.marketResearchDescList4`,
    defaultMessage: 'Dostupnost određenih profila na tržištu',
  },
  MarketResearchDescList5: {
    id: `${scope}.marketResearchDescList5`,
    defaultMessage: 'Kako unaprediti employer branding',
  },
  EstimatesAndTests: {
    id: `${scope}.estimatesAndTests`,
    defaultMessage: 'Procene i testovi',
  },
  EmployeeDevelopment: {
    id: `${scope}.employeeDevelopment`,
    defaultMessage: 'Razvoj zaposlenih',
  },
  SeeMore: {
    id: `${scope}.seeMore`,
    defaultMessage: 'Vidi više',
  },
});
